import Vue from 'vue'
import AppS from './AppS.vue'
import App from './App.vue'
import AppC from './AppC.vue'
import AppN from './AppN.vue'
import WPAPI from 'wpapi'

Vue.config.productionTip = false
Vue.prototype.$wp = new WPAPI({endpoint: 'https://surgicare.gr/wp-json'})

new Vue({
  render: h => h(AppS),
}).$mount('#app1')

new Vue({
  render: h => h(App),
}).$mount('#app')

new Vue({
  render: h => h(AppC),
}).$mount('#app2')

new Vue({
  render: h => h(AppN),
}).$mount('#app3')
